import React from "react";

const WorkAroundTailwind = () => {
    return (
        <div className="invisible bg-orange border-orange border-yellow bg-yellow border-red bg-red border-green bg-green border-blue bg-blue border-aqua-green bg-aqua-green scale-0 text-blue text-yellow"></div>
    )
}

export default WorkAroundTailwind